/**
 * Created by olegg on 18-May-17.
 */
export const POPULAR_PAGES_RADIO_BUTTON_CLICKED = "POPULAR_PAGES_RADIO_BUTTON_CLICKED";
export const POPULAR_PAGES_UTM_CHECKBOX_CLICKED = "POPULAR_PAGES_UTM_CHECKBOX_CLICKED";
export const POPULAR_PAGES_DATA_FETCHING = "POPULAR_PAGES_DATA_FETCHING";
export const POPULAR_PAGES_DATA_FETCHED = "POPULAR_PAGES_DATA_FETCHED";
export const POPULAR_PAGES_SHOW_REQUEST_MESSAGE = "POPULAR_PAGES_SHOW_REQUEST_MESSAGE";
export const POPULAR_PAGES_HIDE_REQUEST_MESSAGE = "POPULAR_PAGES_HIDE_REQUEST_MESSAGE";
